import { API_TAG_TYPES } from 'constants/apiTagTypes';
import { ACTIVITY_LOG_CATEGORIES, TAG_TYPES_BY_LOG_CATEGORY } from 'constants/activityLog';

const CULTURE_PROJECT_RESTORE_TAGS = [
  { type: API_TAG_TYPES.PROJECTS_JOURNALS, id: 'LIST' },
  { type: API_TAG_TYPES.ACTION_TRACKER, id: 'LIST' },
  { type: API_TAG_TYPES.ACTION_TRACKER_SEGMENTS, id: 'LIST' },
];

export const getRestoredItemTags = ({ id, category } = {}) => {
  const { list, items } = TAG_TYPES_BY_LOG_CATEGORY[category] ?? {};

  if (!list) {
    return [];
  }

  return [
    { type: list, id: 'LIST' },
    ...(id ? items.map((type) => ({ type, id })) : []),
    ...(category === ACTIVITY_LOG_CATEGORIES.CULTURE_PROJECT ? CULTURE_PROJECT_RESTORE_TAGS : []),
  ];
};
